import { CommandingRunStages, CommandingRunTaskData, RUN_STATE } from "@/types/commandingRunTaskTypes";
import { File } from "./file";

export class CommandingRunTask {
  id: string;
  alias: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  commandingRunId: string;
  runState: RUN_STATE;
  statusMessage: string;
  taskResponseYaml: string;
  stage: CommandingRunStages;
  taskOrder: number;
  startTime?: Date | string;
  asset?: File;
  propelOrgId: string;

  constructor(params: CommandingRunTaskData) {
    this.id = params.id;
    this.alias = params.alias || '';
    this.commandingRunId = params.commandingRunId;
    this.updatedAt = params.updatedAt;
    this.createdAt = params.createdAt;
    this.stage = params.stage;
    this.runState = params.runState;
    this.statusMessage = params.statusMessage || '';
    this.taskResponseYaml = params.taskResponseYaml || '';
    this.taskOrder = params.taskOrder;
    this.startTime = params.startTime;
    this.asset = params.asset;
    this.propelOrgId = params.propelOrgId || '';
  }
}

